import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DashboardProvider } from '@/context/DashboardContext';
import { Toaster } from '@/components/ui/sonner';
import Sidebar from '@/components/Sidebar';
import Topbar from '@/components/Topbar';
import Overview from '@/pages/Overview';
import Pipeline from '@/pages/Pipeline';
import Donors from '@/pages/Donors';
import Grants from '@/pages/Grants';
import Geography from '@/pages/Geography';
import Impact from '@/pages/Impact';
import Stories from '@/pages/Stories';
import Resources from '@/pages/Resources';
import GrantProfile from '@/pages/GrantProfile';

function App() {
  return (
    <DashboardProvider>
      <BrowserRouter>
        <div className="app-shell">
          <Topbar />
          <div className="flex flex-1 min-h-0">
            <Sidebar />
            <main className="main-scroll">
              <div className="mock-banner">
                ⚠ Displaying mock data — connect Sahaya grant management API for live figures
              </div>
              <div className="page-container">
                <Routes>
                  <Route path="/"           element={<Overview  />} />
                  <Route path="/pipeline"   element={<Pipeline  />} />
                  <Route path="/donors"     element={<Donors    />} />
                  <Route path="/grants"     element={<Grants    />} />
                  <Route path="/grants/:id" element={<GrantProfile />} />
                  <Route path="/resources"  element={<Resources />} />
                  <Route path="/geography"  element={<Geography />} />
                  <Route path="/impact"     element={<Impact    />} />
                  <Route path="/stories"    element={<Stories   />} />
                </Routes>
              </div>
            </main>
          </div>
        </div>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </DashboardProvider>
  );
}

export default App;
